import { FC } from 'react';

import { DropdownInputName } from 'analytics/events/input-usage';
import { useFormContext } from 'react-hook-form';

import { ActionMeta } from 'react-select';

import { useLocationOptions } from 'mobx/hooks/useLocationOptions';

import Patient from 'models/Patient';

import { FormAutocomplete } from 'components/UIkit/atoms/Dropdown';

interface Props {
  disable?: boolean;
  isRequired?: boolean;
  placeholder?: string;
  name?: string;
  label?: string;
  patient?: Patient;
  trackAnalyticsEvent?: (
    actionMeta: ActionMeta<any>,
    inputName: DropdownInputName,
    isKeyboardSource: boolean,
    hasPreviousValue: boolean
  ) => void;
}

export const PatientLocationAutocomplete: FC<Props> = ({
  disable,
  isRequired,
  placeholder,
  label = 'Primary Location',
  name = 'location',
  patient,
  trackAnalyticsEvent
}) => {
  const { watch } = useFormContext();
  const location = watch(name);
  const locationOptions = useLocationOptions(patient);

  return (
    <FormAutocomplete
      label={label}
      options={locationOptions}
      name={name}
      isRequired={isRequired}
      isDisabled={disable || locationOptions.length === 0}
      placeholder={placeholder}
      getOptionValue={(option: any) => option.value.id}
      onChange={(value, actionMeta, eventKey) =>
        trackAnalyticsEvent &&
        trackAnalyticsEvent(actionMeta, 'Primary Location', eventKey === 'Enter', Boolean(location))
      }
    />
  );
};
